module.exports = __webpack_public_path__ + "img/main_mancharo_icon.e1e56059.png";